export const WORKFLOW_NAME_KEY = 'name';
export const WORKFLOW_TYPE_KEY = 'type';
export const WORKFLOW_CREATION_DATE_KEY = 'creationDate';
export const WORKFLOW_STATUS_KEY = 'status';
export const WORKFLOW_NAME_MAX_CHARACTERS = 120;
